export default __webpack_public_path__ + "static/media/computer.c8fa65d6.png";